import React from "react";
import { useSelector } from "react-redux";
import { onKeyDown } from "../../../../service";
import classes from "./MyGroupList.module.css";

const MyGroupList = ({ myGroup, removeStudent, getClassByNum }) => {

    const texts = useSelector(state => state.translate.texts);

    return (
        <div className={classes.MyGroupListWrapper}>
            <div className={classes.MyGroupList}>
                {myGroup?.map(s =>
                    <div key={s.externalId} className={classes.StudentDetails}>
                        <div className={classes.StudentName}>{s.firstName} {s.lastName}</div>
                        <div>{s.class ? `${getClassByNum(s.class)}'${s.ordinal}` : ''}</div>
                        <div className={classes.Remove} onClick={() => removeStudent(s.externalId)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => removeStudent(s.externalId))}>{texts.remove}</div>
                    </div>
                )}
            </div>
        </div>
    )
}
export default MyGroupList